/**
 * Fire-and-forget beacon called from any location where the legacy-redirect
 * map rescues a URL. The backend logs each hit so ops can see which old
 * WordPress paths are still generating live traffic — the highest-hit
 * legacy paths are candidates for proper new landing pages instead of
 * bare redirects.
 */
export function reportRedirectHit(fromPath, toPath) {
  if (typeof window === 'undefined' || !fromPath || !toPath) return;
  try {
    fetch('/api/redirect-hit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        from_path: fromPath,
        to_path: toPath,
        referrer: document.referrer || '',
      }),
      keepalive: true,
    }).catch((err) => console.debug('[redirect-hit] beacon failed', err));
  } catch (err) {
    console.debug('[redirect-hit] beacon threw', err);
  }
}
